
export default function AboutUs() {
  return (
    <section id="about" className="py-16 md:py-24 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-center">
          <div>
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 md:mb-6">
              弊社について
            </h2>
            <div className="space-y-4 md:space-y-6 text-sm md:text-lg text-gray-700 leading-relaxed">
              <p>
                私たちファーム建設は創業43年の企業です。
              </p>
              <p>
                私たちは出来る限りお客様のご要望に寄り添った形でのサービスを目指しています。
              </p>
              <p>
                不動産購入からリフォームそして管理まで<strong className="text-teal-600">「ワンストップ」</strong>でサービス提供出来るのが強みです。<strong className="text-teal-600">全国エリア</strong>対応しております。
              </p>
              <p>
                日本の社会的問題<strong className="text-teal-600">「空き家問題」</strong>を解決します！
              </p>
              <p>
                眠れる<strong className="text-teal-600">「負動産」</strong>を<strong className="text-teal-600">「不動産」</strong>へ蘇らせて社会貢献します。
              </p>
            </div>

            <div className="mt-6 md:mt-8 p-4 md:p-6 bg-white rounded-xl shadow-lg">
              <h3 className="text-lg md:text-2xl font-bold text-gray-900 mb-3 md:mb-4">ファーム建設の「ファーム」とは？</h3>
              <p className="text-sm md:text-base text-gray-700 leading-relaxed">
                ファームという言葉はよく「牧場」やプロ野球の二軍チームの事をファームチームと呼びますが、弊社のファームの意味とは<strong className="text-teal-600">「堅実」</strong>という意味です。
              </p>
            </div>
          </div>

          <div className="space-y-4 md:space-y-6">
            <div className="relative rounded-xl overflow-hidden shadow-2xl h-64 md:h-96 w-full">
              <img
                src="https://static.readdy.ai/image/4f63d300aa74833e61c135d0fc4d72e6/79e956557867012a6bcc64b547bc1976.png"
                alt="有限会社ファーム建設"
                className="absolute inset-0 w-full h-full object-cover"
              />
            </div>

            <div className="bg-white p-5 md:p-8 rounded-xl shadow-lg">
              <h3 className="text-lg md:text-2xl font-bold text-gray-900 mb-3 md:mb-4">当社先代社長の藤井寅三の言葉</h3>
              <div className="space-y-4">
                <div className="border-l-4 border-teal-500 pl-4">
                  <p className="text-sm md:text-base text-gray-700 mb-2">
                    「誰もが辛い時や悲しい時でも帰れる場所が家だと思う。そんなホっと出来る場所を創りたいと思って家創りをしてきました」
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
